export default "/images/app_store_badge.png";